import { TCollapseProps } from './Collapse.types';
import { SCollapse } from './Collapse.styles';

export const Collapse = ({ ...props }: TCollapseProps) => {
  return <SCollapse {...props} />;
};
